import { NavLink } from "react-router-dom";

const DataTable = ({ ingredients, unitOfMeasureEntities, handleDelete }) => {

    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th className="text-left" width="20%">Code</th>
                    <th className="text-left" width="20%">Name</th>
                    <th className="text-left" width="20%">Unit</th>
                    <th className="text-left">Description</th>
                    <th className="text-left" width="1%"/>
                    <th className="text-left" width="1%"/>
                </tr>
            </thead>
            <tbody>
                {ingredients.map(ingredient => 
					<tr key={ingredient.id}>
						<td>{ingredient.code}</td>
						<td>{ingredient.name}</td>
						<td>{unitOfMeasureEntities[ingredient.unit_of_measure_id]?.name}</td>
						<td>{ingredient.description}</td>
						<td className="text-right">
							<NavLink to={`/data/ingredients/${ingredient.id}`} className="btn btn-primary btn-icon">
                                <span className="las la-pen" />
                            </NavLink>
                        </td>
						<td className="text-right">
							<button className="btn btn-danger btn-icon" onClick={() => handleDelete(ingredient)}>
                                <span className="las la-trash-alt" />
                            </button>
						</td>
					</tr>
				)}
            </tbody>
        </table>
    );
}
 
export default DataTable;